import SuperiorCountriesActionType from 'actions/superiorCountries/superiorCountriesActionType';

export const getSuperiorCountries = (params, key = 'first') => ({
  type: SuperiorCountriesActionType.GET_SUPERIOR_COUNTRIES,
  payload: { params, key },
});

export const saveSuperiorCountries = (data, key = 'first') => ({
  type: SuperiorCountriesActionType.SAVE_SUPERIOR_COUNTRIES,
  payload: { data, key },
});

export const resetSuperiorCountries = (key = 'first') => ({
  type: SuperiorCountriesActionType.RESET_SUPERIOR_COUNTRIES,
  payload: { key },
});

export const editSuperiorCountries = (data) => ({
  type: SuperiorCountriesActionType.EDIT_SUPERIOR_COUNTRIES,
  payload: { data },
});

export const deleteSuperiorCountries = (data) => ({
  type: SuperiorCountriesActionType.DELETE_SUPERIOR_COUNTRIES,
  payload: { data },
});
